import React from 'react';
import { useIntersection, useValueTracking } from './hooks.mjs';

const IntersectionObserver = /*#__PURE__*/React.memo(function IntersectionObserver({
  children,
  root,
  rootMargin,
  threshold,
  unsupportedBehavior,
  wrapperComponent: Wrapper = 'div',
  onIntersectionChange
}) {
  const [intersection, ref] = useIntersection({
    root,
    rootMargin,
    threshold,
    unsupportedBehavior
  });
  useValueTracking(intersection, newValue => onIntersectionChange(newValue));
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref
  }, children);
});

export { IntersectionObserver };
